import Cookies from "js-cookie"

const slideOuts = document.getElementsByClassName("slide-out-toast")

for (let slideOut of slideOuts) {
  if (!Cookies.get(slideOut.getAttribute("id") + "-dismissed")) {
    slideOut.classList.add("show")

    slideOut.addEventListener("click", (e) => {
      const target = e.target
      if (isElement(target, "close")) {
        slideOut.classList.remove("show")
        Cookies.set(slideOut.getAttribute("id") + "-dismissed", true)
      } else if (isElement(target, "slide-out-header")) {
        console.log("here")
        const slideOutBodies = slideOut.getElementsByClassName("slide-out-body")
        slideOutBodies[0].classList.toggle("hidden")
      }
    })
  }
}

function isElement(element, className) {
  return element.classList.contains(className) || element.closest(`.${className}`)
}
